import React from 'react';
import { connect } from 'react-redux';
import { cohortUrl, newRequestUrl } from '@/constants/urls';
import DropdownItem from '@/components/DropdownItem';
import StandardToolsMenu from '@/components/tools/StandardToolsMenu';
import { requestSources } from '@/requests/constants';
import { showDatasetConditions } from '@/datasets/conditions/actions';
import { confirmCohortDeletion } from '../actions';
import { showShareCohort } from '../sharing/actions';
import { cohortPermissions } from '../constants';
import cohortStatus from '../status/helper';

const CohortTools = ({
  accessRequestAllowed,
  accessRequestSupported,
  allowAudit,
  allowDelete,
  allowSecure,
  allowShare,
  category,
  cohort,
  hasConditions,
  listItem = false,
  newRequestCode,
  share,
  showConditions,
  showDelete,
  upward,
  url,
}) => (
  <StandardToolsMenu
    allowDelete={allowDelete}
    allowRead
    href={url}
    listItem={listItem}
    onDelete={() => showDelete(category, cohort.code)}
    upward={upward}
  >
    {(allowShare || allowSecure) && (
    <DropdownItem
      icon={(allowSecure && !allowShare) ? 'shield' : 'share alternate'}
      textId={(allowSecure && !allowShare) ? 'actions.security' : 'actions.share'}
      onClick={() => share(category, cohort.code)}
    />
    )}
    {accessRequestAllowed && accessRequestSupported && (
    <DropdownItem
      icon="key"
      textId="actions.request.access"
      href={newRequestUrl(requestSources.COHORT, cohort.code, newRequestCode, '#')}
    />
    )}
    {hasConditions && (
    <DropdownItem
      icon="clipboard list"
      textId="actions.conditions"
      onClick={() => showConditions(requestSources.COHORT, cohort.code, cohort.name)}
    />
    )}
    {allowAudit && (<DropdownItem icon="history" textId="actions.audit" href={`${cohortUrl(cohort, '#')}/audits`} />)}
  </StandardToolsMenu>
);

const mapStateToProps = ({
  auth: { role },
  requests: { newRequestCode },
}, { cohort }) => {
  const { cohorts } = role.permissions;
  const { permissions } = cohort;

  return ({
    allowAudit: cohort.audit && permissions[cohortPermissions.AUDIT],
    allowDelete: cohorts.destroy
        && cohort.permissions[cohortPermissions.DESTROY],
    allowSecure: cohorts.secure && cohort.permissions[cohortPermissions.SECURITY],
    allowShare: cohorts.share && (cohort.permissions[cohortPermissions.INVITE_MEMBER]
        || cohort.permissions[cohortPermissions.REMOVE_MEMBER]),
    newRequestCode,
    ...cohortStatus(role, cohort),
  });
};

const mapDispatchToProps = {
  showDelete: confirmCohortDeletion,
  share: showShareCohort,
  showConditions: showDatasetConditions,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortTools);
